export default "__VITE_ASSET__DmE3BUnA__"